import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * EntEar icon
 *
 * @category Medical
 */
const EntEar = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M9.615 5.997C13.44 1.01 22.36 2.462 23.892 8.75c2.262 6.257-5.337 25.029-12.745 19.112-1.912-1.752-1.922-4.545-2.103-7.038-.49-4.776-3.003-10.543.45-14.667l.121-.15zm8.14-1.843C12.087 2.903 7.632 8.09 8.723 13.495c.34 2.343 1.812 4.686 1.842 6.998.03 1.192-.31 2.333-.34 3.524-.26 2.753 2.723 4.976 5.236 3.635 6.297-3.524 12.464-21.105 2.483-23.458l-.2-.04zm-5.697 2.934c2.423-2.093 6.708-2.133 8.75.52 1.772 2.303 1.422 5.927.2 8.67-1.642 3.114-1.782 1.702-.81-.77.82-2.303 1.3-5.236-.341-7.279-1.522-1.922-4.906-2.022-6.858-.44-.47.31-2.223 2.082-.951 1.882.71-.2 1.592-.691 2.363-.931 1.231-.591 3.794-.05 3.794.4-.03.28-.43.24-.71.3-3.545-.19-7.13 2.293-5.077 6.108.791 1.601 2.373 3.043 2.533 4.895.02.37-.06.711-.25.991-.58.871-2.072.521-1.792.09.24-.27.69-.42.83-.81.201-1.552-1.44-3.064-2.142-4.426-1.802-2.733-2.232-6.888.33-9.08l.14-.12z"
        />
      </svg>
    );
  }
);

EntEar.displayName = 'EntEar';

export { EntEar };
